import React from 'react';
import { createRoot } from 'react-dom/client';

import { ContentContainer as ArtistBioItemContentContainer } from './artist/ArtistContainer.jsx';
import { ContentContainer as ArtistItemContentContainer } from './artist/ItemContainer.jsx';
import { ContentContainer as CertificateItemContentContainer } from './certificate/ItemContainer.jsx';
import { Component as LineItemCell } from './common/LineItemCell.jsx';
import { Component as ConsignmentLineItemCell } from './consignment/LineItemCell.jsx';
import * as FontImports from './utility/FontImports.jsx';
import { ContentContainer as MosaicItemContentContainer } from './mosaic/ItemContainer.jsx';
import PageHeader from './common/PageHeader.jsx';
import { Component as PaymentCreditCell } from './invoice/PaymentCreditCell.jsx';
import { Component as PricelistItemCell } from './pricelist/ItemCell.jsx';
import { ContentContainer as TearsheetItemContentContainer } from './tearsheet/ItemContainer.jsx';
import Types from './utility/Types.jsx';
import Utilities from './utility/Utilities.jsx';

const dropAreaId = 'dropArea';
function Body(props) {
    return <BodyContent {...props}>{props.children}</BodyContent>
}

function _BodyContent(props) {
    if (props.builder) {
        switch (props.configType) {
            case Types.Name.Content.ArtistBioItem:
                return <ArtistBioItemContentContainer editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.ArtistInventoryItem:
                return <ArtistItemContentContainer editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.CertificateItem:
                return <CertificateItemContentContainer editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.ConsignmentLineItem:
                return <ConsignmentLineItemCell editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.CreditLineItem:
            case Types.Name.Content.PaymentLineItem:
                return <PaymentCreditCell editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.InvoiceLineItem:
                return <LineItemCell editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.MosaicItem:
                return <MosaicItemContentContainer editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.PageHeader:
                return <PageHeader editor={true} id={dropAreaId} {...props} />
            case Types.Name.Content.PricelistInventoryItem:
                return <PricelistItemCell editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.PurchaseOrderLineItem:
                return <LineItemCell editor={true} id={dropAreaId} index={0} {...props} />
            case Types.Name.Content.TearsheetItem:
                return <TearsheetItemContentContainer editor={true} id={dropAreaId} index={0} {...props} />
        }
    }
    const data = props.data || {};
    const gallery = data.Gallery || {};
    const styleguide = data.Styleguide || {};
    let bodyFont;
    if (styleguide.BodyFont) {
        bodyFont = styleguide.BodyFont.FontFamily;
    }
    let width = "100%";
    let style = { fontWeight: 'normal', margin: 0, minWidth: width, width };
    if (props.collateralType == 0 || props.collateralType == 3) {
        // Email
        switch (props.configType) {
            case Types.Name.Config.Invoice:
            case Types.Name.Config.Offer:
            case Types.Name.Config.PurchaseOrder:
                width = '800';
                break;
            default:
                width = '600';
                break;
        }
        style.minWidth = `${width}px`;
        style.width = `${width}px`;
    }
    const hasPageHeader = Types.hasPageHeader(props.configType);
    let handleDrop = props.onDrop;
    if (props.onDocumentProps) {
        style = { ...style, ...props.onDocumentProps() };
    } else if (props.onPageProps) {
        if (!hasPageHeader || props.builder) {
            const pageProps = props.onPageProps();
            if (pageProps && pageProps.config && pageProps.config.Style) {
                style = { ...style, ...Utilities.Config.getStyle(pageProps.config.Style) };
            }
        }
    } else if (props.config.Config && props.config.Config.document && props.config.Config.document.config && props.config.Config.document.config.Style) {
        handleDrop = undefined;
        if (!hasPageHeader || props.builder) {
            style = { ...style, ...Utilities.Config.getStyle(props.config.Config.document.config.Style) };
        }
    }
    return (
        <table
            border="0"
            cellPadding="0"
            cellSpacing="0"
            className={props.className}
            width="100%"
            onDragOver={props.onDragOver}
            onDrop={handleDrop}>
            <tbody>
                <tr>
                    <td align="center" valign="top">
                        <table border="0" cellPadding="0" cellSpacing="0" className="mobile-shell" width={width}>
                            <tbody>
                                <tr>
                                    <td className="td" style={style}>
                                        <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                                            <tbody>
                                                {
                                                    !Utilities.isNullOrWhitespace(gallery.Message) &&
                                                    <tr>
                                                        <td className="main">
                                                            <div className="message-content" dangerouslySetInnerHTML={{ __html: gallery.Message }} style={{ color: '#000000', fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '14px', lineHeight: 'normal' }} />
                                                        </td>
                                                    </tr>
                                                }
                                                {
                                                    props.collateralType == 0 &&
                                                    <tr>
                                                        <td className="main" style={{ padding: '20px 0px' }}>
                                                            <div dangerouslySetInnerHTML={{ __html: gallery.Signature }} style={{ color: styleguide.FontColor, fontFamily: bodyFont, fontSize: '16px' }} />
                                                        </td>
                                                    </tr>
                                                }
                                                <tr>
                                                    <td className="main">
                                                        {props.content}
                                                    </td>
                                                </tr>
                                                {
                                                    !Utilities.isNullOrWhitespace(data.Ad) &&
                                                    (props.collateralType == 0 || props.collateralType == 2 || props.collateralType == 3) &&
                                                    <tr>
                                                        <td className="main" style={{ paddingTop: '20px' }}>
                                                            <div dangerouslySetInnerHTML={{ __html: data.Ad }} style={{ color: styleguide.FontColor, fontFamily: bodyFont, fontSize: '16px' }} />
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
const BodyContent = withConfigRendering(_BodyContent, ['Config', 'blocks']);

function Frame(props) {
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: props.config });
    return (
        <FrameContainer id={`${props.collateralType || 'renderedCollateral'}-${visibilityHash}`} head={<Head builder={props.builder} collateralType={props.collateralType} data={props.data} styles={props.styles} />} {...props}>
            <Body {...props} />
        </FrameContainer>
    );
}

class FrameContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this._cancelRender = this._cancelRender.bind(this);
        this._handleRef = this._handleRef.bind(this);

        this.renderFrameContent = this.renderFrameContent.bind(this);
    }

    componentDidMount() {
        this.renderFrameContent();
    }

    componentDidUpdate() {
        if (this.state.id == this.props.id) {
            return;
        }
        this.renderFrameContent();
    }

    componentWillUnmount() {
        this._cancelRender();
    }

    _cancelRender() {
        if (this.renderHandle) {
            clearTimeout(this.renderHandle);
            this.renderHandle = null;
        }
    }

    _handleRef(ref) {
        this.frameRef = ref;
    }

    renderFrameContent() {
        if (this.frameRef && this.updater && this.updater.isMounted && this.updater.isMounted(this)) {
            const doc = this.frameRef.contentDocument;
            if (doc && doc.readyState === 'complete' && doc.getElementById('frameContent') != null) {
                if (!this.headRoot) {
                    this.headRoot = createRoot(doc.head);
                }
                this.headRoot.render(this.props.head);

                const contentContainer = doc.getElementById('frameContent');
                const currentTarget = this.frameRef;
                if (contentContainer && contentContainer.children && contentContainer.children.length == 0 && this.props.onLoad) {
                    const component = this;
                    setTimeout(function () {
                        component.props.onLoad({ currentTarget });
                    }, 10);
                }
                if (!this.childrenRoot) {
                    this.childrenRoot = createRoot(contentContainer);
                }
                this.childrenRoot.render(this.props.children);

                if (!this.props.builder) {
                    this.setState({
                        id: this.props.id
                    });
                }
                return;
            }
        }
        // Wait for the iframe to be ready
        this._cancelRender();
        this.renderHandle = setTimeout(this.renderFrameContent, 0);
    }

    render() {
        return <iframe id={this.props.id} ref={this._handleRef} className={this.props.className} srcDoc="<div id='frameContent' />" style={this.props.style} />;
    }
}

function Head(props) {
    const data = props.data || {};
    const styleguide = data.Styleguide || {};
    let bodyFont;
    if (styleguide.BodyFont) {
        bodyFont = styleguide.BodyFont.FontFamily;
    }
    let pointerEvents = 'unset';
    if (!props.builder && props.collateralType != 0) {
        pointerEvents = 'none';
    }
    let html = `
        body {
            background: none;
            color: ${styleguide.FontColor};
            display: block !important;
            font-family: ${bodyFont};
            font-size: 12pt;
            margin: 0 !important;
            padding: 0 !important;
            pointer-events: ${pointerEvents};
            min-width: 100% !important;
            width: 100% !important;
        }
        p {
            margin: 0;
            padding: 0;
        }
        table {
            border-spacing: 0;
        }
        .pageBreakAfterAlways {
            page-break-after: always;
        }
        .pageBreakInsideAvoid {
            page-break-inside: avoid;
        }
    `;
    if (props.collateralType == 2 || props.collateralType == 3) {
        html += `.main td { font-size: 0; line-height: 1; } .main td > div, .main td > span { font-size: 16px; }`;
    }
    if (props.builder) {
        html += `.main td, #dropArea td { line-height: 1; }`;
    }
    if (props.styles) {
        html += props.styles;
    }
    const styles = <style dangerouslySetInnerHTML={{ __html: html }} />;
    return (
        <React.Fragment>
            {/* 
                    <!--[if gte mso 9]>
                    <xml>
                        <o:OfficeDocumentSettings>
                        <o:AllowPNG/>
                        <o:PixelsPerInch>96</o:PixelsPerInch>
                        </o:OfficeDocumentSettings>
                    </xml>
                    <![endif]--> 
                    */}
            <meta httpEquiv="Content-type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
            <meta name="format-detection" content="date=no" />
            <meta name="format-detection" content="address=no" />
            <meta name="format-detection" content="telephone=no" />
            <FontImports.Legacy data={props.data} type={props.collateralType} />
            <FontImports.GoogleFontImport config={styleguide} />
            {styles}
        </React.Fragment>
    )
}

function withConfigRendering(WrappedComponent, configPath) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            const config = props.contentConfig || props.config;
            this.state = {
                config,
                hash: Utilities.Config.getVisibilityHash(config),
                kit: this._processKit(props)
            };

            this._processKit = this._processKit.bind(this);
            this.handleComponent = this.handleComponent.bind(this);
        }

        shouldComponentUpdate(nextProps, nextState) {
            if (nextProps.builder) {
                return true;
            }
            if (this.state.config && nextProps.config && this.state.config.id != nextProps.config.id) {
                return true;
            }
            const nextHash = Utilities.Config.getVisibilityHash(nextProps.config);
            if (nextHash != nextState.hash) {
                this.setState({
                    hash: nextHash
                });
                return true;
            }
            return false;
        }

        componentDidUpdate(prevProps) {
            const config = this.props.contentConfig || this.props.config;
            if (this.state.config && config && this.state.config.id != config.id) {
                this.setState({
                    config
                });
            }
            if (this.props.stylesheetId != prevProps.stylesheetId) {
                this.setState({
                    kit: this._processKit(this.props)
                });
            }
        }

        _processKit(props) {
            const kit = {};
            let kitContent = props.stylesheet;
            if (props.data && props.data.Styleguide) {
                kit.colors = {};
                if (props.data.Styleguide.FontColor) {
                    kit.colors.body = props.data.Styleguide.FontColor;
                }
                if (props.data.Styleguide.HeaderColor) {
                    kit.colors.header = props.data.Styleguide.HeaderColor;
                }
                if (!kitContent && props.data.Styleguide.Documents && props.data.Styleguide.Documents.Kit && props.data.Styleguide.Documents.Kit[Types.Kit.Type.Global]) {
                    kitContent = props.data.Styleguide.Documents.Kit[Types.Kit.Type.Global];
                }
            }
            if (!kitContent) {
                return kit;
            }
            for (let key in kitContent) {
                if (!kitContent[key]) {
                    continue;
                }
                const elementStyle = Utilities.extractStyle(kitContent[key].design, key);
                if (!elementStyle) {
                    continue;
                }
                kit[key] = elementStyle;
            }
            return kit;
        }

        handleComponent(d, contentBefore, contentAfter) {
            if (!this.state.config) {
                return null;
            }
            const block = Types.getBlock(Utilities.Config.getBlockType(d), this.state.config.Type, undefined);
            if (!block || !block.component) {
                return null;
            }
            const BlockComponent = block.component;
            let blockProps = {};
            if (this.props.onBlockProps) {
                blockProps = this.props.onBlockProps(d);
            }
            let className = blockProps.className;
            if (this.props.builder) {
                if (className) {
                    className += ' draggable';
                } else {
                    className = 'draggable';
                }
                if (blockProps.active) {
                    className += ' draggable-active';
                }
            }
            return (
                <BlockComponent
                    key={d.Id || d.id}
                    builder={this.props.builder}
                    className={className}
                    collateralConfig={this.state.config}
                    collateralType={this.props.collateralType}
                    config={blockProps.config || blockProps.block || d}
                    configType={this.props.configType}
                    contentAfter={contentAfter}
                    contentBefore={contentBefore}
                    data={this.props.data || {}}
                    dragging={this.props.dragging}
                    editor={this.props.editor}
                    forcePageHeader={this.props.forcePageHeader}
                    forceVisibility={this.props.forceVisibility}
                    kit={this.state.kit}
                    preview={this.props.preview}
                    serverSide={this.props.serverSide}
                    onBlockProps={this.props.onBlockProps}
                    onClick={this.props.onBlockClick}
                    onComponent={this.handleComponent}
                    onDragEnter={this.props.onDragEnter}
                    onDragStart={this.props.onBlockDragStart} />
            );
        }

        render() {
            let content;
            if (this.state.config && configPath) {
                let config = this.state.config;
                for (let i = 0; i < configPath.length; i++) {
                    config = config[configPath[i]];
                    if (!config) {
                        break;
                    }
                }
                if (config) {
                    content = []
                    if (!this.props.builder && Types.hasPageHeader(this.props.configType)) {
                        let contentAfter = [], contentBefore = [];
                        let itemConfig;
                        config.forEach((d) => {
                            if (d.Type == 'itemContainer' || (d.type && d.type.value == Types.Name.Block.Inventory.Container)) {
                                itemConfig = d;
                                return;
                            }
                            const BlockComponent = this.handleComponent(d);
                            if (!BlockComponent) {
                                return;
                            }
                            if (itemConfig) {
                                contentAfter.push(BlockComponent);
                            } else {
                                contentBefore.push(BlockComponent);
                            }
                        });
                        if (!itemConfig) {
                            content = contentBefore.concat(contentAfter);
                        } else {
                            const BlockComponent = this.handleComponent(itemConfig, contentBefore, contentAfter);
                            if (BlockComponent) {
                                content = [BlockComponent];
                            }
                        }
                    } else {
                        config.forEach((d) => {
                            const BlockComponent = this.handleComponent(d);
                            if (!BlockComponent) {
                                return;
                            }
                            content.push(BlockComponent);
                        });
                    }
                }
            }
            if (this.props.builder == true) {
                content = (
                    <>
                        {
                            Types.hasPageHeader(this.props.configType) &&
                            <PageHeader kit={this.state.kit} {...this.props} />
                        }
                        <div id={dropAreaId}
                            className={this.props.dragging ? 'dragging' : undefined}
                            onDragEnter={this.props.onDragEnter}
                            onDragOver={(e) => { if (e) { e.preventDefault() } }}
                            onDrop={this.props.onDrop}>
                            <div id="top-hidden-exit" className="hidden draggable" onDragEnter={this.props.onDragEnter} />
                            <div id="top-hidden-enter" className="hidden draggable" onDragEnter={this.props.onDragEnter} />
                            {content}
                            <div id="bottom-hidden-enter" className="bottom-hidden hidden draggable" onDragEnter={this.props.onDragEnter} />
                            <div id="bottom-hidden-exit" className="bottom-hidden hidden draggable" onDragEnter={this.props.onDragEnter} />
                        </div>
                    </>
                )
            }
            return (
                <WrappedComponent {...this.props} config={this.state.config || {}} content={content} kit={this.state.kit}>
                    {this.props.children}
                </WrappedComponent>
            );
        }
    }
}

export {
    Body,
    Frame,
    Head,
    Types,
    Utilities
};